import { Checkbox } from "@mui/material";
import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import { ArrowLeft2 } from "../../assets";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    activeStep: number;
    step: number;
    stepTitle: string;
    stepDesc: string;
    onClick?:any;
    latestStep?:string;
    children?:ReactElement;
}
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
export function StepperItem({ activeStep, step, stepTitle, stepDesc , onClick , latestStep , children}: Props): ReactElement {
    return (
        <div className="stepper-item">
            <div className={`${latestStep ? latestStep : "" } d-flex align-items-center ` }onClick={onClick}>
                {step < activeStep ?
                    <Checkbox {...label} checked={true} sx={{

                        color: "#155a9e",
                        '&.Mui-checked': {
                            color: "#155a9e",
                        },
                        '&.MuiCheckbox-root': {
                            padding: 0
                        }

                    }} />

                    :

                    <span className="circlar">

                    </span>
                }
                <div className="stepper-item-content">
                    <span className={`${step > activeStep ? "step-deactive " : "step-active"} step`}>
                        {stepTitle}
                    </span>
                    <span className={`${step > activeStep ? "step-deactive" : "step-active"} step-title`}>
                        {stepDesc}

                    </span>

                </div>

                {step === activeStep &&
                    <img src={ArrowLeft2} alt="هامرز" className="stepper-item-arrow" />
                }
            </div>


            {children &&
<>
                {children}
</>
            }

        </div>
    )
}

export default StepperItem;